export enum VoiceHintOld {
  Loading = 'loading',
  Start = 'start',
  Stop = 'stop',
  Successful = 'successful',
  Error = 'error',
}

export enum VoiceHint {
  FirstRecording = 'firstRecording',

  /** The second training recording. */
  Training2 = 'training2',
  /** The third (and usually final) training recording. */
  Training3 = 'training3',
  /** Training recordings 4 and after, which mean preivous trainings weren't enough. */
  Training4 = 'training4',

  /**
   * The first verification recording. This will only be seen if we've previously done training.
   * In a pure verification route, this will be overwritten by FirstRecording.
   */
  Verification1 = 'verification1',
  /** The second (and usually final) verification recording. */
  Verification2 = 'verification2',
  /** Verification recordings 3 and after, which mean previous verirications weren't enough. */
  Verification3 = 'verification3',

  /** The last recording was so short it was discarded. No progress was made. */
  TooShort = "tooShort",
  /** The last recording was so long it was discarded. No progress was made. */
  TooLong = "tooLong",
  /** The last recording was too quiet. No progress was made. */
  TooQuiet = "tooQuiet",

  /** Waiting for background uploads to complete. */
  WaitingForUploads = "waitingForUploads",
  /** Polling the server to see how we're doing. */
  Polling = 'polling',
}
